<template>
  <div>
    <div>
      <van-card
        desc="描述信息"
        title=""
        thumb="https://img.yzcdn.cn/vant/ipad.jpeg"
      >
        <div slot="desc" style="font-size: 0.9rem">
          <div style="margin-top: 1rem">订单编号: 20252254455</div>
          <div style="margin-top: 0.6rem">开票金额: ￥ 3800.00</div>
        </div>
      </van-card>
      <div>
        <div :v-model="item">
          <van-cell-group>
            <van-field
              v-model="item.invoiceheader"
              maxlength="11"
              label="发票抬头"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="item.enterpriseTaxNumber" label="企业税号" />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="item.billingContent" label="开票内容" />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="item.invoiceAmount" label="发票金额" />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="item.remarks" label="备注" />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="item.email" label="收票邮箱" />
          </van-cell-group>
          <van-cell-group>
            <div style="width: 100%; height: 6rem">
              <div style="text-align: center">
                备注：发票开具后不支持内容修改
              </div>
            </div>
          </van-cell-group>
        </div>
      </div>
    </div>
    <div>
      <div>
        <van-cell-group>
          <van-field
            v-model="item.invoiceheader"
            maxlength="11"
            label="发票抬头"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="item.enterpriseTaxNumber" label="企业税号" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="item.billingContent" label="开票类型" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="item.invoiceAmount" label="联系电话" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="item.remarks" label="邮箱地址" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="item.email" label="发票备注" />
        </van-cell-group>
      </div>
    </div>
  </div>
</template>
 
<script>
import Vue from "vue";
import { Button,
  Cell,
  CellGroup,
  Col,
  Dialog,
  Field,
  Form,
  Icon,
  Row,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Toast,
  Divider,
  Card } from "vant";
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(cell);
export default {
    components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [Divider.name]: Divider,
    [Card.name]:Card,
  },
  data() {
    return {
      item: {
        invoiceheader: "411554454",
        enterpriseTaxNumber: "4545121545",
        billingContent: "开票内容",
        invoiceAmount: "12.23",
        remarks: "测试测试",
        email: "112658222@qq.com",
      },
    };
  },
};
</script>
 
<style scoped>
.list-content {
  margin-top: 46px;
  overflow: scroll;
}
.list-item {
  text-align: center;
}
</style>